<div class="wrapper-list-stores">
  <div class="section-title">
    <div class="row">
      <div class="col">
        <div class="d-flex align-items-center">
          <a
            routerLink="/dashboard/product-faq"
            class="btn btn-back" [attr.aria-label]="'Back' | translate">
            <i class="fi-rr-arrow-alt-left"></i>
          </a>
          <div class="title" [attr.data-parent]="'Product FAQs' | translate">{{ "Create Product FAQs" | translate }}</div>
        </div>
      </div>
      <div class="col text-right">
        <div class="d-inline-block">
          <button class="btn btn-primary" (click)="createFaq()">
            {{ "Create FAQs" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="section-main">
    <div class="row order-card my-2">
      <div class="col-lg-4 col-sm-12 mt-3">
        <div
          class="bg-white rounded-md shadow-sm p-4 px-2 md:!p-3 mb-6 text-center"
        >
          <div class="row">
            <div class="col pr-1">
              <p class="value-text">
                {{ "Select your country" | translate }}
              </p>
              <div
                ngbDropdown
                class="d-inline-block w-100"
                [class]="{ 'is-loading': !countryLoaded || !countryFirstInit }"
              >
                <button
                  class="btn btn-outline-primary w-100"
                  id="dropdownBasic2"
                  ngbDropdownToggle
                >
                  {{ getCountryName(filteredCountry) | translate }}
                </button>
                <div
                  ngbDropdownMenu
                  aria-labelledby="dropdownBasic2"
                  class="custom-dropdown"
                >
                  <button
                    ngbDropdownItem
                    *ngFor="let c of activatedCountry"
                    (click)="changeCountry(c.country_code)"
                  >
                    {{ c.country_name | translate }}
                  </button>
                </div>
              </div>
            </div>
            <div class="col pl-1">
              <p class="value-text">
                {{ "Select your language" | translate }}
              </p>
              <div
                ngbDropdown
                class="d-inline-block w-100"
                [class]="{ 'is-loading': !countryLoaded || !countryFirstInit }"
              >
                <button
                  class="btn btn-outline-primary w-100"
                  id="dropdownBasic2"
                  ngbDropdownToggle
                >
                  {{ getLanguageName(currentLanguage) || "Language" }}
                </button>
                <div
                  ngbDropdownMenu
                  aria-labelledby="dropdownBasic2"
                  class="custom-dropdown"
                >
                  <button
                    ngbDropdownItem
                    *ngFor="let language of languageList"
                    (click)="changeLanguage(language)"
                  >
                    {{ language.language_name }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="ml-lg-2 mb-2 my-lg-1">
            <input
              class="input-field mt-2"
              type="text"
              name="product-filter"
              id="product-filter"
              [value]="productFilter"
              (input)="productFilterChanged($event)"
              placeholder="{{ 'Search product by name...' | translate }}"
            />
          </div>

          <div *ngIf="productFilter.length">
            <span class="text-slate-400 text-sm">{{
              "Searching for '{0}'..." | translate : [productFilter]
            }}</span>
          </div>

          <div
            class="product-list overlow-y-hidden overflow-x-hidden custom-scrollbar mt-3"
          >
            <div *ngIf="loading">
              <div class="loading-spinner col-12 mt-5">
                <mat-spinner class="mx-auto mt-5" [diameter]="50"></mat-spinner>
              </div>
            </div>
            <div *ngIf="!loading" cdkDropListGroup>
              <div
                class="justify-center flex flex-wrap ease-in-out duration-300 py-2 pl-2 mr-2"
                [class]="isTileView ? 'divide-y divide-slate-200/50 ' : ''"
              >
                <div
                  *ngFor="let item of getDisplayedProducts()"
                  class="select-none product-item-tile duration-1000 transition ease-in-out"
                  [class]="
                    isTileView
                      ? 'w-full group -mb-1'
                      : 'xl:w-[48%] lg:w-[48%] md:w-[32%] w-[48%]'
                  "
                >
                  <div
                    class="flex relative transition bg-white duration-300 ease-in-out shadow-sm hover:!shadow-lg group cursor-pointer"
                    [class]="
                      isTileView
                        ? 'flex-row p-2 border !border-gray-200 hover:!bg-slate-50 dark:hover:!bg-slate-800 group-first:!rounded-t-md group-last:!rounded-b-md'
                        : 'flex-column border !border-transparent rounded hover:!border-indigo-200'
                    "
                    (click)="productClick(item.p_id, item.mixture_arr)"
                  >
                    <div
                      class="aspect-square content-center p-1"
                      [class]="isTileView ? 'w-14 h-14' : 'h-auto w-full '"
                    >
                      <div class="relative pt-[100%]">
                        <div
                          class="absolute z-[1]"
                          [class]="
                            isTileView ? '-left-2 -top-2' : 'right-1 top-1 '
                          "
                        >
                          <div
                            #tooltip="matTooltip"
                            [matTooltip]="getCountryName(item?.country_code)"
                            matTooltipPosition="above"
                            matTooltipHideDelay="100"
                            class="rounded-full border-2 border-white relative shadow overflow-hidden bg-white"
                            [class]="isTileView ? '' : 'right-1 top-1'"
                          >
                            <img
                              [src]="getFlagImageURL(item?.country_code)"
                              class="object-cover"
                              [class]="isTileView ? 'w-4 h-4' : 'w-6 h-6'"
                            />
                          </div>
                        </div>
                        <img
                          [src]="item.image"
                          class="absolute inset-0 object-cover rounded h-full w-full'"
                        />
                        <!-- [class]="isListView ? 'h-auto w-auto' : 'h-full w-full'" -->
                      </div>
                    </div>
                    <div
                      class="flex justify-between w-[65%]"
                      [class]="isTileView ? 'px-2 ' : 'px-3 py-3 !pt-2'"
                    >
                      <div class="text-start truncate self-center">
                        <div
                          class="capitalize text-sm font-medium text-start truncate"
                        >
                          {{ item.product_name?.toLowerCase() }}
                        </div>
                        <div class="text-xs font-normal text-slate-600">
                          {{
                            item.retail_price_per_item
                              | currency
                                : item.currency
                                : item.currency_symbol + " "
                          }}
                        </div>
                      </div>
                    </div>

                    <div
                      class="flex aspect-square content-center place-content-center p-1"
                      [class]="isTileView ? 'w-14 h-14' : 'h-auto w-full '"
                    >
                      <label class="pointer-events-none self-center text-2xl">
                        <input
                          type="checkbox"
                          class="checkbox-product hidden peer"
                          [checked]="isProductSelected(item.p_id)"
                          name="productSelection"
                          id="{{ item.p_id }}"
                        />
                        <i
                          class="peer-checked:block hidden fas fa-check-circle text-emerald-500"
                        ></i>
                        <i
                          class="peer-checked:hidden block fas fa-circle text-slate-200"
                        ></i>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="mt-5" *ngIf="!getDisplayedProducts()?.length">
                  <span>{{ "No product found." | translate }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-8 col-sm-12 mt-3" *ngIf="loading">
        <div class="loading-spinner col-12 mt-3 pb-3">
          <mat-spinner class="mx-auto" [diameter]="50"></mat-spinner>
        </div>
      </div>
      <div class="col-lg-8 col-sm-12 mt-3">
        <form [formGroup]="generateForm">
          <div class="container max-w-screen-lg mx-auto pl-0">
            <div class="trumbowyg-media-selector d-none">
              <form
                id="trumbowyg-media-selector-event-transport"
                (setInsertImageCallback)="
                  handleSetInsertImageCallback($event)
                "
              >
                <media-selector
                  id="media-selector-embed"
                  [(mediaID)]="editorMediaPhotoId"
                  [(imgURL)]="editorImgURL"
                  (mediaChanged)="handleTrumbowygMediaChanged($event)"
                  class="d-none"
                ></media-selector>
              </form>
              <textarea class="text-textarea"></textarea>
            </div>
            <div class="bg-white rounded-md shadow-sm p-4 px-4 md:p-8 mb-3">
              <label
                class="value-text font-weight-bold mb-1 required"
                for="product_faq_title"
              >
                {{ "Title" | translate }}
              </label>
              <input
                class="h-10 border mt-1 rounded px-3 w-full bg-gray-50"
                type="text"
                name="product_faq_title"
                formControlName="product_faq_title"
                id="product_faq_title"
                required
              />
              <label
                class="value-text font-weight-bold mb-1 mt-3 required"
                for="product_faq_desc"
              >
                {{ "Description" | translate }}
              </label>
              <textarea
                type="text"
                name="product_faq_desc"
                id="product_faq_desc"
                class="border mt-1 rounded p-4 w-full bg-gray-50 h-[15rem] content-editor-textarea"
              ></textarea>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

</div>